module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bM7wG6/tc-custom/9783988267818.jpg?1704453169964",
      "alt": "This image is the cover for the book Bunny Brown and His Sister Sue on the Rolling Ocean, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bunny Brown and His Sister Sue on the Rolling Ocean, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The story revolves around Bunny Brown and his sister Sue who are excited to train their new puppy, Splash, to perform tricks. With the help of their friend, Jimmy Wibblewobble, they teach Splash a variety of tricks such as rolling over, sitting up, and playing dead. They also participate in a dog show and demonstrate Splash's abilities to a panel of judges. In the end, Splash wins the top prize, making Bunny and Sue proud of their hard work and dedication.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Lee Hope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laura Lee Hope is the pseudonym for numerous writers under the Stratemeyer Syndicate including Edward Stratemeyer (1862-1930) himself, his daughter Harriet Stratemeyer Adams (1892-1982), Howard Roger Garis (1873–1962), and his wife Lilian McNamara Garis (d.1954) who wrote the Bobbsey Twins juvenile series. The Bobbsey Twins were first created in 1904 by Stratemeyer, who would come to perfect the sleuthing novel formula that was so popular at the time and remains in print today. His ghost writers churned out novels at an extraordinary rate for many of the Syndicate series including Nancy Drew, Tom Swift, and the Hardy Boys.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0